var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-file-input',{attrs:{"truncate-length":"15","rules":_vm.input.rules ? _vm.input.rules : [],"append-icon":_vm.input.required ? 'mdi-asterisk' : '',"label":_vm.$t(_vm.input.label),"outlined":""},on:{"change":_vm.upload},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})
}
var staticRenderFns = []

export { render, staticRenderFns }